export const environment = {
  production: false,
  serverUrlSalaryLoans:
    "https://gb-salaryloans-dev-api-popular.avaldigitallabs.com/salaryloans/salaryloans-core/",

  serverTapUrl:
    "https://gb-salaryloans-dev-api-popular.avaldigitallabs.com/salaryloans/",

  security: {
    cipherPublicKeyUrl:
      "https://7kzbg9b5j1.execute-api.us-east-2.amazonaws.com/dev/cipher/public-key",
    symmetricKeyUrl:
      "https://7kzbg9b5j1.execute-api.us-east-2.amazonaws.com/dev/cipher/symmetric-key",
  },

  encryptUrls: [
    "https://gb-salaryloans-dev-api-popular.avaldigitallabs.com/salaryloans/salaryloans-core/payrollCheck/client/status",
    "https://gb-salaryloans-dev-api-popular.avaldigitallabs.com/salaryloans/salaryloans-core/features/all",
  ],
};
